// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header */
ion-title {
  text-align: center;
  font-size: 16px;
}

.btnIcon {
  text-align: center;
}

#title {
  display: flex;
  align-items: center;
}

/* Fin Header */
ion-row {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

@media screen and (max-width: 320px) {
  ion-title {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/client/user-form/user-form.component.scss"],"names":[],"mappings":"AAAA,WAAA;AACA;EACE,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA,eAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAAF;;AAMA;EACE;IACE,eAAA;EAHF;AACF","sourcesContent":["/* Header */\r\nion-title {\r\n  text-align: center;\r\n  font-size: 16px;\r\n}\r\n\r\n.btnIcon {\r\n  text-align: center;\r\n}\r\n\r\n#title {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Fin Header */\r\n\r\nion-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n}\r\n\r\n\r\n\r\n\r\n@media screen and (max-width : 320px) {\r\n  ion-title {\r\n    font-size: 13px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
